// plugin for api related methods
import axios from 'axios';

// todo add user_id to header
const axiosPlugin = {
    install (Vue /*options*/) {
        Vue.prototype.$axios = axios.create({
            //withCredentials: true,
            baseURL: process.env.VUE_APP_API_BASE_URL,
            headers: {
                get: {
                    'Accept': 'application/json',
                },
                'Authorization':`Bearer ${''}`,
                'Content-Language': 'et',
                'X-SWIS': JSON.stringify({site_id: null}),
            }
        });
    }
}

export default axiosPlugin;
